.ez{font-size:0.75rem;}